export default "__VITE_PUBLIC_ASSET__18fdc1c9__"